import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Bank, BankState } from '@/modules/settings/bank/types/types.ts'

const initialState: BankState = {
  selected: undefined,
  isOpenModal: false,
  isDeleteModalOpen: false
}

const bankSlice = createSlice({
  name: 'bankss',
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<Bank | undefined>) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const banksActions = bankSlice.actions
export const { reducer: banksReducer } = bankSlice
